import { render } from "./instructor-three.vue?vue&type=template&id=4408aef1"
import script from "./instructor-three.vue?vue&type=script&lang=js"
export * from "./instructor-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__